export default "__VITE_ASSET__CJZwrXu8__"